import Styles from '../index.mobile.module.scss';
import { Button, Form, Input, TextArea, Selector } from 'antd-mobile';
import Agreement from '../../commonComponents/agreement';
import { useRef, useState } from 'react';
import { phoneNumberValidator } from '../../../utils/common';
import Success from '../../commonComponents/success';
import { SlPopup, InputSelect } from '../../antdmComponents/index';

interface SectorMapItem {
  itemValue: string;
  itemName: string;
}

interface IProps {
  suggestions: {
    titleText: string;
    titleDesc: string;
  };
  sectorMap: SectorMapItem[];
  bizMap: SectorMapItem[];
  onCreate: Function;
}

enum OperateTypes {
  industry = 'industry',
  businessType = 'businessType',
}

const MobileConsult = ({
  suggestions,
  sectorMap,
  bizMap,
  onCreate,
}: IProps) => {
  const [agree, setAgree] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const SlPopupRef = useRef(null);
  const [operateType, setOperateType] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [form] = Form.useForm();
  const operateTypeOptions = {
    [OperateTypes.businessType]: bizMap,
    [OperateTypes.industry]: sectorMap,
  };

  const handleSubmit = async (values) => {
    if (values) {
      values[OperateTypes.businessType] = getOptionName(
        bizMap,
        values[OperateTypes.businessType].split('、'),
        false
      );
      values[OperateTypes.industry] = getOptionName(
        sectorMap,
        [values[OperateTypes.industry]],
        false
      )[0];
      const res = await onCreate(values);
      if (res) {
        setSuccess(true);
      }
    }
  };

  const showPopup = (type: OperateTypes) => {
    setOperateType(type);
    const initialNames = form.getFieldValue(type)?.split('、') || [];
    const initialValues = getOptionName(
      operateTypeOptions[type],
      initialNames,
      false
    );
    setSelectedOptions(initialValues);
    SlPopupRef.current.open();
  };
  const SlPopupOk = () => {
    let temp = getOptionName(operateTypeOptions[operateType], selectedOptions);
    form.setFieldsValue({ [operateType]: temp.join('、') });
    SlPopupRef.current.close();
  };
  /**
   * 根据name or value 返回对应的值, 默认根据value 返回 name
   * @param options
   * @param valuesOrNames
   * @param isName
   */
  function getOptionName(options, valuesOrNames, returnName = true) {
    let temp = [];
    const targetField = returnName ? 'itemName' : 'itemValue';
    const currentField = returnName ? 'itemValue' : 'itemName';
    valuesOrNames.forEach((item) => {
      const option = options.find((a) => a[currentField] === item);
      if (option) {
        temp.push(option[targetField]);
      }
    });
    return temp;
  }

  return (
    <>
      {success ? (
        <Success text={'您的建议已收到，我们会尽快安排专家与您联系'} />
      ) : (
        <div className={Styles.formContainer}>
          <div className={Styles.formLabel}>{suggestions.titleText}</div>
          <div className={Styles.formDesc}>{suggestions.titleDesc}</div>
          <Form
            layout="horizontal"
            form={form}
            footer={
              <Button
                className={Styles.submitBtn}
                block
                type="submit"
                color="primary"
                size="large"
                disabled={!agree}
              >
                提交
              </Button>
            }
            onFinish={handleSubmit}
            className={Styles.form}
            requiredMarkStyle="asterisk"
          >
            <Form.Item
              className={Styles.formList}
              name="contactUser"
              label="联系人"
              rules={[
                {
                  required: true,
                  message: '请输入联系人姓名',
                  whitespace: true,
                },
              ]}
            >
              <Input placeholder="请输入联系人姓名" maxLength={20} />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="phoneNum"
              label="联系方式"
              validateTrigger="onblur"
              layout="horizontal"
              rules={[
                { validator: phoneNumberValidator() },
                { required: true, message: '请输入联系方式', whitespace: true },
              ]}
            >
              <Input
                placeholder="请输入手机号"
                type="number"
                pattern="[0-9]*"
              />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="company"
              label="公司名称"
              layout="horizontal"
              rules={[
                { required: true, message: '请输入公司名称', whitespace: true },
              ]}
            >
              <Input placeholder="请输入公司名称" />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="industry"
              label="所在行业"
              layout="horizontal"
              rules={[
                { required: true, message: '请选择所在行业', whitespace: true },
              ]}
            >
              <InputSelect
                placeholder="请选择所在行业"
                onClick={() => showPopup(OperateTypes.industry)}
              />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="businessType"
              label="业务类型"
              layout="horizontal"
              rules={[
                { required: true, message: '请选择业务类型', whitespace: true },
              ]}
            >
              <InputSelect
                placeholder="请选择业务类型"
                onClick={() => showPopup(OperateTypes.businessType)}
              />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="question"
              label="咨询问题"
              rules={[
                { required: true, message: '请输入咨询问题', whitespace: true },
              ]}
              layout="vertical"
            >
              <TextArea
                className={Styles.textArea}
                rows={5}
                maxLength={200}
                placeholder="请详细填写您的咨询问题"
              />
            </Form.Item>
            <Form.Item className={Styles.formAgreement}>
              <Agreement
                text="已阅读并同意StreamLake"
                onChange={(val) => {
                  setAgree(val);
                }}
              />
            </Form.Item>
          </Form>
          <SlPopup
            ref={SlPopupRef}
            title={
              operateType === OperateTypes.businessType
                ? '选择业务'
                : '选择行业'
            }
            onOk={SlPopupOk}
          >
            <Selector
              multiple={operateType === OperateTypes.businessType}
              options={(operateType === OperateTypes.businessType
                ? bizMap
                : sectorMap
              ).map((item) => {
                return {
                  label: item.itemName,
                  value: item.itemValue,
                };
              })}
              value={selectedOptions}
              columns={operateType === OperateTypes.businessType ? 2 : 3}
              className={Styles.radioBtn}
              showCheckMark={false}
              onChange={(val) => setSelectedOptions(val)}
            />
          </SlPopup>
        </div>
      )}
    </>
  );
};

export default MobileConsult;
